export default __webpack_public_path__ + "static/media/picTuanPhan.da71effb.png";